<template>
  <div class="wrapper__runnerup">
      <h4>Runners up</h4>
      <ul class="">
        <li
          v-for="player in playerList"
          :key="`runnerup-${player.name}`"
          class="runnerup"
        >
          <div class="image">
            <img
              :src="image(player.name).Img200"
              :alt="player.name"
            />
          </div>
          <div class="badge">
            <img
              :src="team(player.team).badge"
              :alt="`${player.team} team badge`"
            />
          </div>
          <p>{{ player.name }}</p>
        </li>
      </ul>
    </div>

</template>


<script>
export default {
  name: 'runners-up',
  props: {
    players: {
      type: String,
      required: true,
    },
  },
  components: {},
  data () {
    return {
      playerList: []
    }
  },
  methods: {
    image (nameToFind) {
      const name = nameToFind
        .replace(/\s+/gi, '')
        .replace(/-+/gi, '')
        .replace(/'+|’+|‘+/gi, '')
        .toLowerCase()
      const image = this.$root.content.allImages[name]
      if (!image) {
        return this.$root.content.allImages.profile
      }
      return image
    },
    team (team) {
      return this.$root.content.teams[team.toLowerCase().replace(/\s+/gi, '_')]
    }

  },
  computed: {},
  mounted () {
    this.playerList = this.players
      .split(/,\s+/)
      .map(player => {
        const name = player.trim().split('(')[0]
        const team = player.trim().split('(')[1].replace(')', '')
        return { name, team }
      })
  }
}
</script>


<style scoped lang="sass">
@import index

.wrapper__runnerup
  h4
    text-transform: uppercase
    text-align: center
  ul
    display: flex
    justify-content: center
    padding: 0
    li
      flex: 1 1 auto
      list-style: none
      text-align: center
      margin: 0
      padding: 0 4px
      .image
        width: 80px
        height: 80px
        border-radius: 100px
        margin: 0 auto
        overflow: hidden
        img
          width: 100%
          height: 100%
          object-fit: cover
          margin: 0
      .badge
        width: 30px
        height: 30px
        border-radius: 100px
        border: solid 1px rgba(white, 0.6)
        margin: 0 auto
        transform: translate(0, -33%)
        overflow: hidden
        img
          margin: 0

</style>



// WEBPACK FOOTER //
// src/components/dally-m/runner-up.vue